import { render, staticRenderFns } from "./PatientTable.vue?vue&type=template&id=d7a986c4&scoped=true&"
import script from "./PatientTable.vue?vue&type=script&lang=js&"
export * from "./PatientTable.vue?vue&type=script&lang=js&"
import style1 from "./PatientTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a986c4",
  null
  
)

export default component.exports